(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/roundlist.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/roundlist.js');

'use strict';

svs.game_results.views.RoundList = Marionette.CollectionView.extend({
  className() {
    return 'round-list';
  },
  childView: svs.game_results.views.Round
});

 })(window);